import Vue from 'vue'
import App from './App.vue'
import jQuery from 'jquery'
import fsvs from '@/js/fsvs.js'

global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')
fsvs(window.$)

Vue.config.productionTip = false

new Vue({
  render: (h) => h(App)
}).$mount('#app')
